<template>
  <div :id="'infinite-loading-container_' + ct" :style="listHeight">
    <v-list v-if="ertesitesek.length > 0">
      <template v-for="(item, i) in ertesitesek">
        <k-ertesites-lista-item :key="item.Id" :source="item">
        </k-ertesites-lista-item>
        <v-divider
          class="primary"
          v-if="i < ertesitesek.length - 1"
          :key="'d' + item.Id"
        ></v-divider>
      </template>
    </v-list>
    <template v-else>
      <v-list v-if="showSkeleton && ertesitesekLoading">
        <template v-for="item in 15">
          <v-skeleton-loader :key="item" type="list-item-avatar-two-line">
          </v-skeleton-loader>
          <v-divider v-if="item != 15" :key="'d' + item"></v-divider>
        </template>
      </v-list>
      <k-nodata-info v-else-if="showSkeleton">
        <template v-slot:icon>
          <i class="fas fa-bell"></i>
        </template>
        <template v-slot:text>
          {{ nyelvesites['nincs_ertesites_text'] }}
        </template>
      </k-nodata-info>
    </template>
    <infinite-loading
      @infinite="GetHirek"
      :forceUseInfiniteWrapper="'#infinite-loading-container_' + ct"
      :identifier="'infinite-loading_' + ct"
    >
      <div slot="no-more">
        <span class="text--primary">***</span>
      </div>
      <div slot="no-results"></div>
      <div slot="error"></div>
      <div slot="spinner"></div>
    </infinite-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import uniqBy from 'lodash/uniqBy';
import { NotificationFunctions } from '../../functions/NotificationFunctions';
import InfiniteLoading from 'vue-infinite-loading';
import { timeout } from '../../utils/common';
import { uzenetService } from '../../services/UzenetService';
import { AppStoreTypes } from '../../store/modules/app';
import { AppFunctions } from '../../functions/AppFunctions';
import { useWindow } from '../../utils/vue/useWindow';
let ct = 0;
export default {
  name: 'k-ertesites-lista',
  data() {
    return {
      ertesitesekLoading: true,
      showSkeleton: false,
      ertesitesek: [],
      ct: ct++,
    };
  },
  setup() {
    let { windowSize } = useWindow();
    return { windowSize };
  },
  async mounted() {
    await timeout(10);
    this.showSkeleton = true;
  },
  created() {},
  methods: {
    async GetHirek($state) {
      let result = [];
      try {
        result = await uzenetService.GetErtesiteseim({
          utolsoUzenetId: this.utolsoErtesites?.Id,
        });
        let ertesitesekUpdated = [...this.ertesitesek, ...result];
        this.ertesitesek = uniqBy(ertesitesekUpdated, 'Id');
      } catch (error) {
        NotificationFunctions.AjaxError({
          error,
        });
      }
      if ($state) {
        if (result.length > 0) {
          $state.loaded();
        } else {
          $state.complete();
        }
      }
      this.ertesitesekLoading = false;
    },
  },
  computed: {
    ...mapGetters({
      user: AppStoreTypes.user.get,
    }),
    utolsoErtesites() {
      return this.ertesitesek[this.ertesitesek.length - 1] ?? null;
    },
    listHeight() {
      let bottomNavHeight = this.$vuetify.application.bottom;
      //prettier-ignore
      return `height: calc(${this.windowSize.height}px - 160px);overflow-y: scroll;`;
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {},
  props: {},
  components: {
    InfiniteLoading,
  },
};
</script>
